const recurringInput = {
  repeatEvery: 'חזור כל',
  repeatOn: 'חזור ב',
  ends: 'מסתיים',
  endsOn: 'מסתיים ב',

  form: {
    month: 'חודש',
    day: 'יום',
    week: 'שבוע',
    year: 'שנה',
    occurrences: 'התרחשויות',
    after: 'לאחר',
    never: 'לעולם לא',
    on: 'בתאריך',
  },
};

export default recurringInput;
